import { z } from 'zod';

export const SubscriptionPlanSchema = z.enum([ 'free', 'pilot', 'pro', 'agency', 'enterprise' ]);
export type SubscriptionPlan = z.infer<typeof SubscriptionPlanSchema>;
